import React, { useId } from "react";
type PapelPicadoProps = {
  className?: string;
  size?: "sm" | "md";
  animated?: boolean;
  /** Adds paper fold, cast shadow and a 3D sway so flags feel dimensional. */
  depth?: boolean;
  /** Shifts the row by half a flag — used for a layered back row. */
  offset?: boolean;
  showString?: boolean;
};
const FLAG_COLORS = ["#E8871E", "#C1272D", "#1CA7A8", "#0F6B4A", "#1F4E9C", "#F2C230", "#D6336C"];
const FLAG_COUNT = 26;
export function PapelPicado({
  className = "",
  size = "md",
  animated = true,
  depth = false,
  offset = false,
  showString = true
}: PapelPicadoProps) {
  const baseId = useId().replace(/:/g, "");
  const width = size === "sm" ? "w-9 sm:w-11" : "w-12 sm:w-16";
  const motionClass = animated ? depth ? "papel-flag-3d" : "papel-flag" : depth ? "papel-flag-still" : "";
  return <div aria-hidden="true" className={`pointer-events-none relative overflow-hidden ${className}`} data-id="element-91" data-mp="1sza2f2rmzxgc">
      {showString && <div className="absolute inset-x-0 top-[3px] h-px bg-agavedeep/50" data-id="element-92" data-mp="1xxtnl0yep57n" />}
      <div className={`flex justify-center gap-1.5 sm:gap-2 ${offset ? "translate-x-[22px] sm:translate-x-[26px]" : ""}`} data-id="element-93" data-mp="3uuw3f1s5giv5">
        {Array.from({
        length: FLAG_COUNT
      }).map((_, index) => {
        const maskId = `papel-${baseId}-${index}`;
        const color = FLAG_COLORS[(index + (offset ? 3 : 0)) % FLAG_COLORS.length];
        return <svg key={maskId} viewBox="0 0 60 72" className={`${width} flex-none ${motionClass}`} style={animated ? {
          animationDelay: `${index % 7 * -0.6}s`
        } : undefined} data-id="element-94" data-mp="hnb2ku599xwe" data-mpi={index}>
              <defs data-id="element-95" data-mp="qel5vd62x8ea">
                <mask id={maskId} data-id="element-96" data-mp="qf3c92mgh2zx">
                  <path fill="white" d="M0 0H60V62L55 68L50 62L45 68L40 62L35 68L30 62L25 68L20 62L15 68L10 62L5 68L0 62Z" data-id="element-97" data-mp="mejepxxyzxd9" />
                  <g fill="black" data-id="element-98" data-mp="vezdiu3rqgbs">
                    {[8, 19, 30, 41, 52].map(x => <circle key={x} cx={x} cy={12} r={1.6} data-id="element-99" data-mp="vd4pv8144a40" />)}
                    <circle cx="30" cy="36" r="10" data-id="element-100" data-mp="3p8s70jwx12xo" />
                    <path d="M30 17l3 4-3 4-3-4z" data-id="element-101" data-mp="3t7rd47udv5qp" />
                    <path d="M30 47l3 4-3 4-3-4z" data-id="element-102" data-mp="3t6gawcgl661p" />
                    <path d="M11 36l4-3 4 3-4 3z" data-id="element-103" data-mp="21zqvjjq8d96" />
                    <path d="M41 36l4-3 4 3-4 3z" data-id="element-104" data-mp="20etzn9xwi85" />
                    <circle cx="10" cy="22" r="2" data-id="element-105" data-mp="6tzsrhjcxg8e" />
                    <circle cx="50" cy="22" r="2" data-id="element-106" data-mp="6usprqsikrdc" />
                    <circle cx="10" cy="52" r="2" data-id="element-107" data-mp="br9fuqj9xft2" />
                    <circle cx="50" cy="52" r="2" data-id="element-108" data-mp="gr45kqrbbzcj" />
                  </g>
                  <g fill="white" data-id="element-109" data-mp="gpb1nj833t88">
                    <circle cx="30" cy="36" r="3.5" data-id="element-110" data-mp="ksz81ykzcirw" />
                    <ellipse cx="30" cy="30" rx="2" ry="3.4" data-id="element-111" data-mp="ktipzfamr75x" />
                    <ellipse cx="30" cy="42" rx="2" ry="3.4" data-id="element-112" data-mp="ps2f1okisz2i" />
                    <ellipse cx="24" cy="36" rx="3.4" ry="2" data-id="element-113" data-mp="ppg3lduidzf0" />
                    <ellipse cx="36" cy="36" rx="3.4" ry="2" data-id="element-114" data-mp="2mlncucd9ve9s" />
                  </g>
                </mask>
              </defs>
              <g mask={`url(#${maskId})`} data-id="element-115" data-mp="2rl9tkvsb7cnc">
                <rect width="60" height="72" fill={color} data-id="element-116" data-mp="2jzxrubv6h8qe" />
                {depth && <>
                    {/* paper fold over the string */}
                    <rect width="60" height="6" fill="#000" opacity="0.18" data-id="element-117" data-mp="2a9ur1phteqhi" />
                    <rect y="6" width="60" height="1.5" fill="#fff" opacity="0.35" data-id="element-118" data-mp="2a7s2l9wb95ew" />
                    {/* soft side shading for a curved-paper feel */}
                    <rect width="8" height="72" fill="#000" opacity="0.08" data-id="element-119" data-mp="32ysa3utuorbb" />
                    <rect x="52" width="8" height="72" fill="#fff" opacity="0.1" data-id="element-120" data-mp="2xzp3i5y82d18" />
                  </>}
              </g>
            </svg>;
      })}
      </div>
    </div>;
}